import { Switch, Tooltip, useMantineColorScheme } from "@mantine/core";
import { IconMoonStars, IconSun } from "@tabler/icons-react";
import { useSessionStore } from "stores/userSessionStore";

// The ModeSelection component is a simple UI element that allows users to toggle between different modes (dark|light).
// It uses the Switch component from Mantine to provide a consistent look and feel.
// This component allows users to select a mode for the application.
// It provides buttons for different modes, which can be styled and customized as needed.
const SwitchTheme = () => {
  const { colorScheme, setColorScheme } = useMantineColorScheme();
  const { isGlobalAdmin } = useSessionStore();
  return isGlobalAdmin ? (
    <Tooltip label="Switch Mode" refProp="rootRef">
      <Switch
        size="md"
        styles={{
          track: {
            cursor: "pointer",
          },
          thumb: {
            cursor: "pointer",
          },
        }}
        onChange={(value) => {
          setColorScheme(colorScheme === "dark" ? "light" : "dark");
        }}
        onLabel={
          <IconSun
            size={16}
            stroke={2.5}
            color="var(--mantine-color-yellow-4)"
          />
        }
        offLabel={
          <IconMoonStars
            size={16}
            stroke={2.5}
            color="var(--mantine-color-blue-6)"
          />
        }
      />
    </Tooltip>
  ) : (
    <></>
  );
};

// This component allows users to select a mode for the application.
// It provides buttons for different modes, which can be styled and customized as needed.
export default SwitchTheme;
